import $ from 'jquery';
// import mpro from './mpro.init';

import {
	applyComponentClickRestrictions,
	getOptionsFromDataset,
} from '../../util/dom.js';

import MpDialog from '../../modules/components/dialog.js';


// Export helpers to mpro namespace
mpro.ask = MpDialog.ask.bind(MpDialog);
mpro.confirm = MpDialog.confirm.bind(MpDialog);
mpro.alert = MpDialog.alert.bind(MpDialog);

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	// Confirm dialogs
	// ? Need to use the native event listener to use the capture phase
	document.addEventListener('click', (e) => {
		// @ts-ignore
		if (e?.target?.closest) {
			// @ts-ignore
			const closestConfirm = e.target.closest('[data-confirm]');

			if (closestConfirm) {

				// Disabled element
				if (closestConfirm.classList.contains('disabled')) {
					return;
				}

				// @ts-ignore
				const evtData = e.data;

				// Action already confirmed - pass through
				if (evtData && (evtData.confirmed === true)) {
					return;
				}

				// ? Simulate a jQuery event
				// @ts-ignore
				const $Event = $.Event(e);
				// @ts-ignore
				$Event.currentTarget = closestConfirm;
				// @ts-ignore
				$Event.delegateTarget = closestConfirm;
				// @ts-ignore
				$Event.target = closestConfirm;

				const options = getOptionsFromDataset(closestConfirm, 'confirm', true);

				// Standard component click restrictions
				// @ts-ignore
				if (applyComponentClickRestrictions('confirm', options, $Event) === false) {
					return;
				}

				// Prevent any further action
				$Event.preventDefault();
				$Event.stopPropagation();
				$Event.stopImmediatePropagation();

				// Close all other dialogs
				// MpDialog.closeAll({ closable: true });

				// Close toasts and similar overlays
				mpro.closeSimpleOverlays();

				const $elem = $(closestConfirm);
				const confirmTitle = ($elem.attr('data-bs-original-title') || $elem.attr('title') || $elem.text()).trim() || void 0; // <-- let it fallback to data-confirm-* attributes
				const confirmContent = (typeof closestConfirm.dataset.confirm === 'string') && closestConfirm.dataset.confirm || void 0; // <-- let it fallback to data-confirm-* attributes

				// Display the instance
				MpDialog.confirm({
					relatedTarget: closestConfirm,
					skipDataset: true,
					title: confirmTitle,
					content: confirmContent,
					...options,
					url: null, // <-- make sure the dialog doesn't inherit any url
					okAction: (dialog) => {

						// Close the dialog window
						dialog.hide();

						// Create our event (with options)
						const evt = new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window,
						});

						// @ts-ignore
						evt.data = { confirmed: true };

						// If cancelled, don't dispatch our event
						const cancelled = !closestConfirm.dispatchEvent(evt);

						// Dispatch custom event
						$elem.triggerNative('mp-confirm-dialog');
					},
				});
			}
		}
		// The Capture phase
	}, true);
});

export default mpro;
